import React from 'react'
// @ts-ignore
import { TwitterBlueVerified } from '@netbasequid/core'
import { StyledIconContainer } from '../index.css'

const VerifiedIcon = () => (
  <StyledIconContainer>
    <TwitterBlueVerified fontSize={16} />
  </StyledIconContainer>
)

export default VerifiedIcon
